import React, { Fragment, useEffect, useState } from "react";

import axios from "axios";

import toast from "react-hot-toast";

interface SaveFavoriteNumberProps {
	productType: string;
	inquiryDestination: number;
}

const SaveFavoriteNumber: React.FC<SaveFavoriteNumberProps> = ({
	productType,
	inquiryDestination,
}) => {
	const [nameState, setNameState] = useState<string>("");
	const [destinationState, setDestinationState] = useState<number>(0);

	useEffect((): void => {
		setDestinationState(inquiryDestination);
	}, [inquiryDestination]);

	function saveFavoriteNumber(destination: number, name: string, productType: string): Promise<unknown> {
		interface payloadType {
			tujuan: number;
			nama: string;
			type: string;
		}

		let payload: payloadType = {
			tujuan: destination,
			nama: name,
			type: productType,
		}

		return new Promise((resolve, reject): void => {
			axios({
				url: `${process.env.REACT_APP_API_ENDPOINT_URL}/favorite/saveNumber`,
				method: "POST",
				data: JSON.stringify(payload),
				headers: {
					"Content-Type": "application/json",
					Authorization: localStorage.getItem("user_token"),
				},
				validateStatus: (status): boolean => true,
			}).then((result: any): void => {
				// console.log("[SAVE FAVORITE NUMBER]", result);

				if (result.status === 200) {
					return resolve(result);
				} else {
					return reject(result);
				}

			}).catch((error: any): void => console.log("STATUS CODE", error));
		});
	};

	function handleSubmitSaveFavoriteNumber(e: any): void {
		e.preventDefault();
		if (nameState.length) {
			toast.promise(saveFavoriteNumber(destinationState, nameState, productType),
				{
					loading: "Loading..",
					success: (result: any): string => result.data.message,
					error: (e: any): string => e.data.message,
				},
				{
					style: {
						fontWeight: "bolder",
					},
				}
			);
		} else {
			toast.error("Nama Harus Di Isi", {
				style: {
					fontWeight: "bolder",
				},
			});
		}
	};

	function handleKeyPressValidateNumberOnly(e: any): void {
		var theEvent = e || window.event;
		var key = theEvent.keyCode || theEvent.which;

		if (theEvent.type === "paste") {
			key = e.clipboardData.getData("text/plain");
		} else {
			key = String.fromCharCode(key);

			var regex = /[0-9]|\./;
			if (!regex.test(key)) {
				theEvent.returnValue = false;
				if (theEvent.preventDefault) theEvent.preventDefault();
			}
		}
	};

	return (
		<Fragment>
			<div className="p-3 bg-white shadow-lg rounded-lg mb-3">
				{/* PRODUCT DETAILS */}
				<div className="flex justify-between p-2">
					<div>
						<span className="text-sm sm:text-lg font-medium font-dmsans">Simpan Nomor</span>
					</div>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11.5002 22.75C10.7102 22.75 9.96025 22.34 9.44025 21.64L8.42023 20.3C8.21023 20.02 7.93025 19.86 7.63025 19.84C7.34025 19.82 7.03027 19.96 6.78027 20.21C5.92027 21.13 5.08022 21.57 4.29022 21.55C3.75022 21.53 3.28023 21.29 2.92023 20.85C2.88023 20.8 2.84024 20.73 2.81024 20.66C2.42024 19.82 2.24023 18.68 2.24023 16.97V7.05001C2.24023 5.34001 2.42024 4.21001 2.81024 3.36001C2.84024 3.30001 2.87023 3.24001 2.92023 3.19001C3.27023 2.74001 3.74027 2.50001 4.28027 2.47001C5.08027 2.44001 5.93026 2.90001 6.77026 3.80001C7.02026 4.07001 7.32024 4.20001 7.62024 4.18001C7.92024 4.16001 8.20022 4.00001 8.41022 3.72001L9.43024 2.37001C9.95024 1.67001 10.7002 1.26001 11.4902 1.26001C12.2802 1.26001 13.0302 1.67001 13.5502 2.37001L14.5602 3.71001C14.7702 4.00001 15.0602 4.16001 15.3702 4.18001C15.6602 4.20001 15.9702 4.06001 16.2202 3.80001C17.0402 2.92001 17.8502 2.47001 18.6302 2.47001C19.1902 2.47001 19.7103 2.72001 20.0703 3.19001C20.1103 3.24001 20.1502 3.30001 20.1802 3.37001C20.5702 4.21001 20.7502 5.35001 20.7502 7.06001V16.98C20.7502 18.69 20.5702 19.82 20.1802 20.67C20.1402 20.76 20.0903 20.84 20.0203 20.91C19.7103 21.31 19.2002 21.56 18.6302 21.56C17.8502 21.56 17.0402 21.11 16.2202 20.23C15.9802 19.97 15.6502 19.83 15.3702 19.85C15.0602 19.87 14.7802 20.03 14.5602 20.32L13.5502 21.66C13.0402 22.34 12.2902 22.75 11.5002 22.75ZM7.58026 18.33C7.62026 18.33 7.67027 18.33 7.71027 18.33C8.45027 18.37 9.14023 18.76 9.61023 19.39L10.6302 20.74C11.1202 21.4 11.8602 21.4 12.3502 20.75L13.3602 19.41C13.8402 18.77 14.5403 18.39 15.2803 18.35C16.0203 18.31 16.7602 18.62 17.3002 19.2C18.0402 19.99 18.4902 20.05 18.6102 20.05C18.6902 20.05 18.7603 20.03 18.8303 19.97C19.1103 19.34 19.2302 18.39 19.2302 16.97V7.05001C19.2302 5.65001 19.1003 4.70001 18.8303 4.07001C18.7503 3.98001 18.6702 3.97001 18.6102 3.97001C18.4902 3.97001 18.0402 4.03001 17.3002 4.82001C16.7602 5.40001 16.0203 5.71001 15.2803 5.67001C14.5303 5.63001 13.8302 5.24001 13.3502 4.61001L12.3403 3.27001C11.8503 2.61001 11.1102 2.61001 10.6202 3.27001L9.60022 4.63001C9.13022 5.26001 8.44026 5.64001 7.70026 5.68001C6.96026 5.72001 6.22024 5.41001 5.68024 4.84001C5.07024 4.18001 4.60027 3.96001 4.34027 3.97001C4.28027 3.97001 4.21025 3.99001 4.13025 4.07001C3.86025 4.70001 3.73022 5.65001 3.73022 7.05001V16.97C3.73022 18.38 3.86025 19.33 4.13025 19.96C4.22025 20.04 4.28027 20.05 4.34027 20.06C4.59027 20.07 5.06023 19.85 5.67023 19.2C6.20023 18.63 6.89026 18.33 7.58026 18.33Z" fill="#292D32" />
							<path d="M16 11H8C7.59 11 7.25 10.66 7.25 10.25C7.25 9.84 7.59 9.5 8 9.5H16C16.41 9.5 16.75 9.84 16.75 10.25C16.75 10.66 16.41 11 16 11Z" fill="#292D32" />
							<path d="M14 14.5H8C7.59 14.5 7.25 14.16 7.25 13.75C7.25 13.34 7.59 13 8 13H14C14.41 13 14.75 13.34 14.75 13.75C14.75 14.16 14.41 14.5 14 14.5Z" fill="#292D32" />
						</svg>
					</div>
				</div>
				<hr />
				<div>
					<div className="w-full flex">
						<input
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNameState(e.target.value)}
							type="text"
							id="swal-input1"
							className="swal2-input text-sm sm:text-base font-inter"
							placeholder="Nama Kontak"
						/>
					</div>
				</div>
				<div>
					<div className="w-full flex">
						<input
							onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => handleKeyPressValidateNumberOnly(e)}
							type="text"
							id="swal-input1"
							className="swal2-input text-sm sm:text-base font-medium font-inter"
							value={destinationState}
							placeholder="Nomor Kontak"
						/>
					</div>
				</div>
				<button
					onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => handleSubmitSaveFavoriteNumber(e)}
					type="submit"
					className="swal2-confirm text-sm sm:text-xs lg:text-base font-inter swal2-styled">
					Simpan
				</button>
			</div>
		</Fragment>
	);
};

export default SaveFavoriteNumber;
